export default __webpack_public_path__ + "static/media/IonOpenOutlineDark.a91766e2.svg";